<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card
          :title="`Branch Info: ${branch.name}`"
          :subtitle="`${branch.city}, ${branch.state}`">
          <template v-slot:append>
            <v-icon icon="mdi-pencil" @click="isBranchInfoEdit = !isBranchInfoEdit">
              <v-tooltip activator="parent" location="end">Edit Branch Info</v-tooltip>
            </v-icon>
          </template>
          <v-card-text v-if="!isBranchInfoEdit">
            <BranchViewComponent :branch="branch"></BranchViewComponent>
          </v-card-text>
          <BranchEditComponent
            v-else
            :branch="branch"
            :allow-close="true"
            :is-create="false"
            @snack="throwSnack"
            @branch-edit-canceled="isBranchInfoEdit = false"
            @branch-edit-complete="isBranchInfoEdit = false">
          </BranchEditComponent>
        </v-card>
      </v-col>
      <v-col>
        <BranchAdminSubView :branch="branch" @snack="throwSnack"></BranchAdminSubView>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <BranchYearsSelectionSubView
          :branch="branch"
          @snack="throwSnack"></BranchYearsSelectionSubView>
      </v-col>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { BranchDTO } from '@/dtos';
import { useBranchStore } from '@/stores/modules/admin';
import { SNACKSTATUS } from '@/stores/util';
import { useSnack } from '@/helpers';
import BranchEditComponent from '@/components/branches/BranchEditComponent.vue';
import BranchViewComponent from '@/components/branches/BranchViewComponent.vue';
import BranchAdminSubView from './BranchAdminSubView.vue';
import BranchYearsSelectionSubView from './subview/BranchYearsSelectionSubView.vue';

const route = useRoute();
const branchId = Array.isArray(route.params.branchId)
  ? route.params.branchId[0]
  : (route.params.branchId ?? '');

const isBranchInfoEdit = ref(false);
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
const branchStore = useBranchStore();

const { data } = branchStore.getBranchByIdQuery(ref(branchId));

const branch = computed(() => {
  return data.value ? new BranchDTO(data.value) : new BranchDTO(); // fallback empty
});
</script>
